import en from './en.json';
import ru from './ru.json';
import zh from './zh.json';
import es from './es.json';
import de from './de.json';
import fr from './fr.json';
import ja from './ja.json';
import hi from './hi.json';
import pt from './pt.json';
import ko from './ko.json';
import it from './it.json';
import kk from './kk.json';

export const landingTranslations = { en, ru, zh, es, de, fr, ja, hi, pt, ko, it, kk };
export function landingCopy(language) { return landingTranslations[language] || en; }
